export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        query_time: '查询时间',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        total_number_of_cases: '案例总数',
        percentage_of_cases: '案例占比',
        number_of_cases: '案例数量',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        query_time: 'Query time',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        total_number_of_cases: 'Total cases',
        percentage_of_cases: 'Percentage of cases',
        number_of_cases: 'Number of cases',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        query_time: 'Abfragezeit',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        total_number_of_cases: 'Gesamtzahl der Fälle',
        percentage_of_cases: 'Prozentsatz der Fälle',
        number_of_cases: 'Anzahl der Fälle',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        query_time: 'Heure de requête',
        reporting_organization_name: 'Nom de l\'organisation de signalement',
        full_query: 'Requête complète',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        total_number_of_cases: 'Total cas',
        percentage_of_cases: 'Pourcentage de cas',
        number_of_cases: 'Cas System-2',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        query_time: 'Tempo di Query',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        total_number_of_cases: 'Numero totale di casi',
        percentage_of_cases: 'Percentuale di Casi',
        number_of_cases: 'Numero di Casi',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        query_time: 'Query time',
        reporting_organization_name: 'Meldende organisatie naam',
        full_query: 'Volledige query',
        organization_code: 'Organisatiecode',
        organization_name: 'Organisatienaam',
        country: 'Land',
        total_number_of_cases: 'Totaal aantal gevallen',
        percentage_of_cases: 'Percentage van gevallen',
        number_of_cases: 'Aantal gevallen',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        query_time: 'Thời gian truy vấn',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        total_number_of_cases: 'Tổng số trường hợp',
        percentage_of_cases: 'Phần trăm các trường hợp',
        number_of_cases: 'Các trường hợp hệ thống',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        query_time: 'Consulta de tiempo',
        reporting_organization_name: 'Nombre de la organización informante',
        full_query: 'Consulta completa',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        percentage_of_cases: 'Porcentaje de casos',
        number_of_cases: 'Cantidad de casos',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Tempo de consulta',
        reporting_organization_name: 'Nome da organização de relatório',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        percentage_of_cases: 'Porcentagem de casos',
        number_of_cases: 'Número de casos',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        query_time: 'Data zapytania',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        total_number_of_cases: 'Łączna liczba spraw',
        percentage_of_cases: 'Odsetek spraw',
        number_of_cases: 'Liczba spraw',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        query_time: 'Sorgulama zamanı',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        total_number_of_cases: 'Dosyaların sayısı',
        percentage_of_cases: 'Davaların yüzdesi',
        number_of_cases: 'Davaların sayısı',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        query_time: 'Čas dotazu',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        total_number_of_cases: 'Celkový počet případů',
        percentage_of_cases: 'Procento případů',
        number_of_cases: 'Počet případů',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        query_time: 'Lekérdezési idő',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        total_number_of_cases: 'Összes eset',
        percentage_of_cases: 'Esetek százaléka',
        number_of_cases: 'Esetek száma',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        query_time: 'Время запроса',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        total_number_of_cases: 'Общее количество случаев',
        percentage_of_cases: 'Процент случаев',
        number_of_cases: 'Количество случаев',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        query_time: 'وقت الاستعلام',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        total_number_of_cases: 'إجمالي عدد الحالات',
        percentage_of_cases: 'نسبة الحالات',
        number_of_cases: 'عدد الحالات',
    },
    // 保加利亚语
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        query_time: 'Време на заявката',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        total_number_of_cases: 'Общ брой случаи',
        percentage_of_cases: 'Процент случаи',
        number_of_cases: 'Брой случаи',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        query_time: 'Forespørgselstidspunkt',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        total_number_of_cases: 'Samlet antal sager',
        percentage_of_cases: 'Procentdel sager',
        number_of_cases: 'Antal sager',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        query_time: 'Hakuaika',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        total_number_of_cases: 'Tapauksien kokonaismäärä',
        percentage_of_cases: 'Tapauksien osuus',
        number_of_cases: 'Tapauksien määrä',
    },
    // 繁体中文（台湾）
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        query_time: '查詢時間',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        total_number_of_cases: '案例總數',
        percentage_of_cases: '案例佔比',
        number_of_cases: '案例數量',
    },
    // 克罗地亚语
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        query_time: 'Vrijeme upita',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        total_number_of_cases: 'Ukupan broj slučajeva',
        percentage_of_cases: 'Postotak slučajeva',
        number_of_cases: 'Broj slučajeva',
    },
    // 拉脱维亚语
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        query_time: 'Vaicājuma laiks',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        total_number_of_cases: 'Gadījumu kopējais skaits',
        percentage_of_cases: 'Gadījumu procents',
        number_of_cases: 'Gadījumu skaits',
    },
    // 立陶宛语
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        query_time: 'Užklausos laikas',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        total_number_of_cases: 'Atvejų skaičius iš viso',
        percentage_of_cases: 'Atvejų dalis',
        number_of_cases: 'Atvejų skaičius',
    },
    // 罗马尼亚语
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        query_time: 'Timpul interogării',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        total_number_of_cases: 'Număr total de cazuri',
        percentage_of_cases: 'Procentul cazurilor',
        number_of_cases: 'Numărul de cazuri',
    },
    // 挪威博克马尔语
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        query_time: 'Spørringstidspunkt',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        total_number_of_cases: 'Totalt antall saker',
        percentage_of_cases: 'Prosentandel saker',
        number_of_cases: 'Antall saker',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Horário da consulta',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        total_number_of_cases: 'Número total de casos',
        percentage_of_cases: 'Percentual de casos',
        number_of_cases: 'Quantidade de casos',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        query_time: 'Förfråganstidpunkt',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        total_number_of_cases: 'Totalt antal fall',
        percentage_of_cases: 'Andel fall (%)',
        number_of_cases: 'Antal fall',
    },
    // 斯洛伐克语
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        query_time: 'Čas dopytu',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        total_number_of_cases: 'Celkový počet prípadov',
        percentage_of_cases: 'Percento prípadov',
        number_of_cases: 'Počet prípadov',
    },
    // 斯洛文尼亚语
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        query_time: 'Čas poizvedbe',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        total_number_of_cases: 'Skupno število primerov',
        percentage_of_cases: 'Odstotek primerov',
        number_of_cases: 'Število primerov',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        query_time: 'เวลาการสอบถาม',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        total_number_of_cases: 'จำนวนกรณีทั้งหมด',
        percentage_of_cases: 'สัดส่วนของกรณี',
        number_of_cases: 'จำนวนกรณี',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        query_time: 'Час запиту',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        total_number_of_cases: 'Загальна кількість випадків',
        percentage_of_cases: 'Частка випадків',
        number_of_cases: 'Кількість випадків',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        query_time: 'Χρόνος ερωτήματος',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        total_number_of_cases: 'Συνολικός αριθμός περιστατικών',
        percentage_of_cases: 'Ποσοστό περιστατικών',
        number_of_cases: 'Αριθμός περιστατικών',
    },
    // 爱沙尼亚语
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        query_time: 'Päringu aeg',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        total_number_of_cases: 'Juhtumite koguarv',
        percentage_of_cases: 'Juhtumite protsent',
        number_of_cases: 'Juhtumite arv',
    },
    // 哈萨克语
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        query_time: 'Сұрау уақыты',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        total_number_of_cases: 'Жағдайлардың жалпы саны',
        percentage_of_cases: 'Жағдайлар пайызы',
        number_of_cases: 'Жағдайлар саны',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        query_time: 'זמן השאילתה',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        total_number_of_cases: 'סך כל המקרים',
        percentage_of_cases: 'אחוז המקרים',
        number_of_cases: 'כמות המקרים',
    },
};
